import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SubCategory from './pages/SubCategory';
import AdminPanel from './pages/AdminPanel';
import TrackApplication from './components/TrackApplication';
import AllServices from './pages/AllServices';
import MyApplications from './pages/MyApplications';
import MyDocuments from './pages/MyDocuments';
import Downloads from './pages/Downloads';
import Contact from './pages/Contact';
import Policy from './pages/Policy';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import GreenCard from './pages/GreenCard';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <FloatingWhatsAppButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<AllServices />} />
        <Route path="/green-card" element={<GreenCard />} />
        <Route path="/track" element={<TrackApplication />} />
        <Route path="/track/:trackId" element={<TrackApplication />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/my-applications" element={<MyApplications />} />
        <Route path="/my-documents" element={<MyDocuments />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogPost />} />
        <Route path="/:category_slug" element={<SubCategory />} />
        <Route path="/:category_slug/:subcategory_slug" element={<SubCategory />} />
        <Route path="/:category_slug/:subcategory_slug/:step" element={<SubCategory />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
